module.exports = __webpack_public_path__ + "img/08-sues-xd.881b74cd.png";